import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 60px; /* Aligns under the topbar */
  left: 0;
  height: calc(100vh - 60px); /* Full height minus topbar */
  width: 300px; /* Matches the grid-template-columns size */
  background-color: var(--mantine-color-body);
  z-index: 5; /* Stays below the topbar when overlapping */
  display: flex;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Line = styled.div`
  border: 1px solid #3c4257;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: ew-resize;
  z-index: 999;
`;

export const Inner = styled.div`
  display: flex;
  flex: 1;
  overflow-x: hidden;
`;

export const Bars = styled.div`
  transition: all 0.3s;
  position: relative;
  display: flex;
  flex: 1;

  &.index-0 {
    transform: translateX(0);
  }

  &.index-1 {
    transform: translateX(-100%);
  }

  &.index-2 {
    transform: translateX(-200%);
  }
`;

export const Bar = styled.div`
  flex: 1;
  min-height: calc(100vh - 520px);
  display: flex;
  flex-direction: column;
`;
